export const categories = [
    {id: 0, name:"MACELLERIA", image:"/imgs/catMacelleria.png"},
    {id: 1, name:"PESCHERIA", image:"/imgs/catPescheria.png"},
    {id: 2, name:"SALUMERIA", image:"/imgs/catSalumeria.png"},
    {id: 3, name:"CONGELATO", image:"/imgs/catCongelato.png"},
    {id: 4, name:"PANETTERIA", image:"/imgs/catPanetteria.png"}
]